module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iNSIgZmlsbD0iIzQyNDI0MiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMgMTNMNS4zMzMzMyAxMC42NjY3TDEwIDE1LjMzMzNMMTkuMzMzMyA2TDIxLjY2NjcgOC4zMzMzM0wxMCAyMEwzIDEzWiIgZmlsbD0iIzFGMUYxRiIgc3Ryb2tlPSIjMUYxRjFGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdrawSetup/choose2.svg
// module id = dZzg
// module chunks = 0